<template>
    <div :style="styleObject" id="app">
        <!--      :style="`color: ${this.style.fontColor} !important;`"-->
        <top-bar v-if="isLoggedIn"></top-bar>
        <div class="top-bar" v-else>
            <LanguageSwitcher></LanguageSwitcher>
            <div class="logo">
                <router-link :to="{name: 'dashboard-main'}"><img src="@/assets/images/logo.png"></router-link>
                </a></div>
        </div>
        <Message :message="$t('messages.tokenExpiry')" class="messages" type="warning"
                 v-if="expiredToken"></Message>
        <router-view/>
        <cookie-consent :button-label="$t('cookies.accept')" :href="$t('cookies.href')"
                        :link-label="$t('cookies.learnMore')" :message="$t('cookies.message')"></cookie-consent>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import TopBar from '@/components/TopBar.vue';
import LanguageSwitcher from '@/components/helpers/LanguageSwitcher.vue';
import {RepositoryFactory} from '@/api/RepositoryFactory';
import Message from '@/components/helpers/Message';
import CookieConsent from 'vue-cookieconsent-component';

const UserRepository = RepositoryFactory.get('users');

export default {
  components: {Message, TopBar, LanguageSwitcher, CookieConsent},
  data() {
    return {
      expirationTime: 0,
    };
  },
  watch: {
    async isLoggedIn(newValue) {
      if (newValue) {
        const {token} = this.$store.getters;
        const headers = await UserRepository.checkTime(token);
        this.expirationTime = parseInt(headers['expiry-millis']);
        if (this.expirationTime !== undefined) {
          this.checkExpiry();
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'isLoggedIn',
      style: 'cssConfig',
      config: 'backendConfig',
    }),
    expiredToken() {
      return this.$store.getters.expired;
    },
    styleObject() {
      return {
        '--base-font-color': this.style.fontColor,
        '--cancel-button-color': this.style.cancelButton,
        '--submit-button-color': this.style.submitButton,
        '--action-link-color': this.style.actionLinkColors,
      };
    },
  },
  methods: {
    checkExpiry() {
      if (this.isLoggedIn) {
        if (this.expirationTime < 0) {
          setTimeout(() => {
            this.expirationTime += 5000;
            this.checkExpiry();
          }, 5000);
        } else {
          this.$store.commit('set_expired', true);
          this.$store.dispatch('logout');
          this.$router.push('/login');
        }
      }
    },
  },

};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">

    @import url('https://fonts.googleapis.com/css?family=Nunito:300,400,700,900&display=swap');
    @import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent";
    @import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-bottom";
    @import "./node_modules/vue-cookieconsent-component/src/scss/cookie-consent-transition";

    html {
        font-size: $baseFontSize;
    }

    body {
        background: $background-color;
        margin: 0;
        line-height: unset !important;

    }

    svg, img {
        box-sizing: unset !important;
        max-width: unset !important;
    }

    #app {
        font-family: 'Nunito', 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: var(--base-font-color);
        background: $background-color;
        // min-height: calc(100vh - 80px);
    }

    .active, .operations a svg {
        color: var(--action-link-color) !important;
        font-weight: 900;
    }

    .operations {
        a, button {
            svg {
                fill: var(--action-link-color) !important;
                stroke: var(--action-link-color) !important;
                color: var(--action-link-color) !important;
            }
        }
    }

    .save {
        background-color: var(--submit-button-color) !important;
    }

    .cancel {
        background-color: var(--cancel-button-color) !important;
    }

    .add-link {
        a, button {
            color: var(--action-link-color) !important;
        }
    }

    .links {
        a {
            color: var(--action-link-color) !important;
        }
    }

    svg {
        fill: var(--action-link-color) !important;
        stroke: var(--action-link-color) !important;
        color: var(--action-link-color) !important;
    }

    .title {
        font-size: rem(30px);
        font-weight: 900;
        line-height: 55px;
        /* color: #878a94; */
        text-align: left;
    }

    .button {
        border-radius: 30px;
        background-color: $peacock-blue;
        border: 1px solid $peacock-blue;
        padding: 11px 50px;
        font-weight: 900;
        font-size: rem(18px);
        color: white;
        cursor: pointer;
        transition: all 300ms ease-in;

        &:hover {
            background-color: white;
            color: $peacock-blue;
        }
    }

    .multiselect {
        .multiselect__select {
            &:before {
                color: $marine-blue;
                border-color: $marine-blue transparent transparent;
            }
        }

        .multiselect__option--highlight, .multiselect__tag {
            background-color: $peacock-blue;
            background-color: var(--action-link-color);
        }

        .multiselect__tag-icon:after {
            color: white;
        }
    }

    .top-bar {
        display: flex;
        background: white;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        justify-content: space-between;
        padding: 18px 53px;
        padding-left: 6px;
        width: 100%;
        position: fixed;
        z-index: 200;
        top: 0;
        left: 0;

        .logo {
            justify-self: flex-end;
            margin-left: auto;
            margin-right: 6%;
        }
    }

    DIV.table {
        display: table;
        background: white;
        /*box-shadow: 0 5px 6px rgba(0, 0, 0, 0.15);*/
        padding: 46px 36px;
        border-radius: 5px;
        margin: 0 auto;
        width: 100%;
        box-sizing: border-box;
        border-collapse: separate;
        // color: $baseTextColor;
        font-size: rem(14px);
    }

    FORM.tr, DIV.tr {
        display: table-row;
    }

    div.tr {
        border: none;

        &:first-child {
            font-weight: bold;

            > .td {
                border-bottom: 1px solid #005fab;
                padding-bottom: 16px;
                line-height: 18px;
                text-align: left;
                font-size: rem(15px);
                font-weight: 900;
            }
        }

        > .td {
            border-top: none;
            font-size: rem(14px);
            line-height: 19px;
        }
    }

    SPAN.td {
        display: table-cell;
        border: none;
        vertical-align: middle;

        &:first-child {
            border-left: none;
        }

        &:last-child {
            border-right: none;

        }
    }

    .multiselect__tag, .multiselect__tags {
        border: none !important;
    }

    .md-datepicker-dialog {
        font-family: 'Nunito', sans-serif;
    }

    .md-datepicker-header {
        background-color: $peacock-blue !important;
        color: white;
    }

    .md-datepicker-body {
        background: white;

        .md-datepicker-week {
            // color: $baseTextColor;
        }

        .md-datepicker-today {
            color: $peacock-blue;
        }

        .md-datepicker-selected {
            background-color: $peacock-blue;
            color: white;
        }
    }

    .md-field {
        width: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        min-height: unset !important;
        max-width: 120px;
        cursor: pointer !important;

        button {
            display: none !important;
        }

        input {
            color: var(--action-link-color) !important;
            cursor: pointer;
            font-weight: bold;
            max-width: 100% !important;
        }

        .md-icon {
            display: none !important;
        }
    }

    .md-datepicker-disabled {
        color: $baseTextColor !important;
    }

    .md-dialog-actions.md-datepicker-body-footer {
        button {
            display: none !important;
        }
    }

    .invalid {
        border: red 1px solid !important;
    }

    button {
        cursor: pointer;
    }

    .md-datepicker-dialog {
        z-index: 20000 !important;
    }

    .button-container {
        @include media('<776px') {
            padding: 15px !important;
        }
    }

    .md-datepicker-body-footer {
        pointer-events: none;
    }

    body {
        transition: all 300ms ease-in;
    }

    .messages {
        position: fixed;
        left: 50%;
        top: 110px;
        transform: translate(-50%, 0);
    }

    .lds-spinner div {
        background: var(--action-link-color) !important;
    }

    .operations {
        a, button {
            svg {
                &.marked, &.removed {
                    color: red !important;
                    fill: red !important;
                    stroke: red !important;
                }
            }
        }
    }

    .marked, .removed {
        color: red !important;
        fill: red !important;
        stroke: red !important;
    }

    .sort-operations {
        padding-left: 15px;
        box-sizing: border-box;
    }

    .pager-wrapper {
        text-align: right !important;

        .pager-pages {
            font-weight: bold;

            a {
                border-radius: 5px !important;
                color: var(--base-font-color) !important;
            }

            .active {
                background-color: var(--action-link-color) !important;
                color: white !important;
                border-color: var(--action-link-color) !important;
                border-radius: 5px;

                &:hover {
                    color: white !important;
                }
            }

            a:hover {
                color: var(--action-link-color) !important;
                border-color: !important;

            }
        }
    }

    .sortable-column {
        padding: 0 15px;
        align-items: center;
    }
</style>
